module.exports = {"440103001":"沙面街道","440103002":"岭南街道","440103003":"华林街道","440103004":"多宝街道","440103005":"昌华街道","440103006":"逢源街道","440103007":"龙津街道","440103008":"金花街道","440103009":"彩虹街道","440103010":"南源街道","440103011":"西村街道","440103012":"站前街道","440103013":"桥中街道","440103014":"白鹤洞街道","440103015":"冲口街道","440103016":"花地街道","440103017":"石围塘街道","440103018":"茶滘街道","440103019":"东漖街道","440103020":"海龙街道","440103021":"东沙街道","440103022":"中南街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440103.json
// module id = 1945
// module chunks = 0